module.exports = __webpack_public_path__ + "static/scale-model-of-allentown-pennsylvania-384929da4881ae675c95c06c50686faa.png";